import React, { useState } from 'react'
import { AiFillStar, AiOutlineStar } from 'react-icons/ai'

// Interactive 1–5 star input.
// Props:
//   value: current rating (0 = none)
//   onChange: (next: number) => void
//   size: px
//   disabled: boolean

const HINTS = ['', 'Pis', 'Orta', 'Yaxşı', 'Çox yaxşı', 'Əla!']

const StarRating = ({
    value = 0,
    onChange,
    size = 28,
    showHint = true,
    disabled = false,
    className = '',
}) => {
    const [hover, setHover] = useState(0)
    const display = hover || value

    return (
        <div className={`flex flex-col items-start gap-1.5 ${className}`}>
            <div className='inline-flex gap-1' onMouseLeave={() => setHover(0)} role='radiogroup' aria-label='Reytinq'>
                {[1, 2, 3, 4, 5].map(s => {
                    const filled = s <= display
                    return (
                        <button
                            key={s}
                            type='button'
                            role='radio'
                            aria-checked={s === value}
                            aria-label={`${s} ulduz`}
                            disabled={disabled}
                            onMouseEnter={() => setHover(s)}
                            onClick={() => !disabled && onChange?.(s)}
                            className={`inline-flex items-center justify-center transition-transform ${disabled ? 'opacity-60 cursor-not-allowed' : 'hover:scale-110 cursor-pointer'}`}
                        >
                            {filled
                                ? <AiFillStar size={size} className='text-warning-500' />
                                : <AiOutlineStar size={size} className='text-slate-300' />
                            }
                        </button>
                    )
                })}
            </div>
            {showHint && display > 0 && (
                <span className='text-xs font-semibold text-slate-500'>
                    {HINTS[display]}
                </span>
            )}
        </div>
    )
}

export default StarRating
